import { useEffect, useState } from "react";
import { FolderOpen, PhoneCall, CalendarCheck, CheckCircle2, ArrowRight } from "lucide-react";
import { adminFetch, STATUS_LABELS, STATUS_COLORS } from "../adminApi";

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function AdminDashboard({ setTab }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    adminFetch("/admin/stats")
      .then((d) => alive && setStats(d))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const counts = stats?.counts || {};
  const cards = [
    { label: "Neue Anfragen", value: counts.neu ?? 0, icon: FolderOpen, testid: "admin-stat-new", hot: true },
    { label: "Offene Anfragen", value: counts.kontaktiert ?? 0, icon: PhoneCall, testid: "admin-stat-open" },
    { label: "Termine vereinbart", value: counts.termin ?? 0, icon: CalendarCheck, testid: "admin-stat-scheduled" },
    { label: "Erledigte Aufträge", value: counts.erledigt ?? 0, icon: CheckCircle2, testid: "admin-stat-done" },
  ];

  return (
    <div className="flex flex-col gap-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <button
            key={c.label}
            data-testid={c.testid}
            onClick={() => setTab("anfragen")}
            className={`rounded-2xl border p-5 text-left transition-colors ${
              c.hot && c.value > 0
                ? "border-blue-500/50 bg-blue-500/10 hover:border-blue-400"
                : "border-[#27272A] bg-[#121215] hover:border-zinc-600"
            }`}
          >
            <c.icon className={`h-5 w-5 ${c.hot && c.value > 0 ? "text-blue-400" : "text-zinc-400"}`} />
            <p className="mt-3 font-display text-3xl font-bold text-zinc-100">{c.value}</p>
            <p className="mt-1 text-xs text-zinc-400 leading-snug">{c.label}</p>
          </button>
        ))}
      </div>

      <div className="rounded-2xl border border-[#27272A] bg-[#121215] p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-base font-semibold text-zinc-100">Neueste Anfragen</h3>
          <button
            onClick={() => setTab("anfragen")}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-blue-400 hover:text-blue-300 transition-colors"
          >
            Alle ansehen <ArrowRight className="h-4 w-4" />
          </button>
        </div>
        {stats && stats.latest?.length === 0 ? (
          <p className="text-sm text-zinc-400">Noch keine Anfragen eingegangen.</p>
        ) : null}
        <div className="flex flex-col gap-2">
          {(stats?.latest || []).map((inq) => (
            <button
              key={inq.id}
              onClick={() => setTab("anfragen")}
              className="flex items-center justify-between gap-3 rounded-xl border border-zinc-800 bg-[#0C0C0E] px-4 py-3 text-left hover:border-zinc-600 transition-colors"
            >
              <div className="min-w-0">
                <p className="text-sm font-semibold text-zinc-100 truncate">
                  {inq.name} · {inq.package}
                </p>
                <p className="text-xs text-zinc-400">
                  {fmtDate(inq.created_at)} · {inq.zip_city}
                </p>
              </div>
              <span className={`shrink-0 rounded-full border px-3 py-1 text-[11px] font-semibold ${STATUS_COLORS[inq.status] || STATUS_COLORS.neu}`}>
                {STATUS_LABELS[inq.status] || inq.status}
              </span>
            </button>
          ))}
        </div>
        <p className="mt-4 text-xs text-zinc-400">
          Umsatz- und Kennzahlen-Statistiken entstehen automatisch, sobald echte Anfragen vorliegen.
        </p>
      </div>
    </div>
  );
}
